import React, { ReactElement } from 'react';
import { Route, Switch } from 'react-router-dom';
import JitsiDialer from '../../shared/components/JitsiDialer/JitsiDialer';

import { MAIN_OPTIONS } from '../../shared/constants/commonConstants';
// import useFreshbot from '../../shared/hooks/useFreshbot';
import { RouteConfig } from '../../shared/models/route.models';
import RoutesConfig from './RoutesConfig';
import { useHistory } from 'react-router';
import { canActivate } from '../../utils/utility';
import IdealTimeout from '../../shared/components/IdealTimeout/IdealTimeout';
import useMasterDataRefresh from '../../shared/hooks/useMasterDataRefresh';
import EmailChannelValidator from '../../shared/components/EmailChannelValidator/EmailChannelValidator';

const PrivateRoutes = (): ReactElement => {

  const routesList: RouteConfig[] = [];
  // useFreshbot();
  useMasterDataRefresh();
  // useBlogsDownloader();

  const history = useHistory();
  const isJitsi = history.location.pathname.includes('jitsi');
  const getFilteredRoutes = (routes: RouteConfig[], roleIds: string[], path: string): RouteConfig[] => {
    return routes
      .filter((route: RouteConfig): boolean =>
        route.path === '*'
        || roleIds.some((id: string): boolean => route.path?.indexOf(id) !== -1))
      .map(({isPublic, path: routePath, component, subRoutes = [], accessCheckKeyword}: RouteConfig): RouteConfig => {
        return { isPublic, component, subRoutes, path: `${path}${routePath}`, accessCheckKeyword };
      });
  };

  const addRoutes = (routes: any[]): RouteConfig[] => {
    return routes.map(({ path, component, subRoutes, accessCheckKeyword }: RouteConfig): any => {
      if (subRoutes && path) {
        addRoutes(getFilteredRoutes(subRoutes, MAIN_OPTIONS, path));
      }
      return routesList.push({ path, component, accessCheckKeyword });
    });
  };

  if (RoutesConfig?.privateRoutes) {
    addRoutes(RoutesConfig.privateRoutes);
  }

  const isVideoCallEnabled = process.env.REACT_APP_IS_VIDEO_CALL_ENABLED === 'false' ? false : true;

  return (
    <React.Fragment>
      <Switch>
        {
          routesList
            .filter(({ accessCheckKeyword = '' }: any): boolean => canActivate(accessCheckKeyword))
            .map((item: RouteConfig): any => {

              return (
                <Route
                  exact={item.isExact}
                  key={item.path}
                  path={item.path}
                  component={item.component}
                />
              );
            },
            )
        }
      </Switch>
      {!isJitsi && isVideoCallEnabled && <JitsiDialer />}
      <IdealTimeout />
      <EmailChannelValidator />
    </React.Fragment>
  );
};

export default PrivateRoutes;
